import React from "react";
import Dropdown from "./Dropdown.js";
import Link from "./Link.js";
import * as StateValueCalculator from "./StateValueCalculations.js";

const URL_PARAM = "priipdefault";

export default class PriipForm extends React.Component {
  constructor(props) {
    super(props);
    this.firstDropdownGeneration = true;

    this.props.configuration.dropdown.forEach((dropdown, index) => {
      dropdown.reactKey = Math.random();
      dropdown.index = index;
      if (typeof dropdown.order === "undefined" || dropdown.order === "") {
        dropdown.order = 10;
      }
    });

    this.props.configuration.linkConfigurations.forEach((link, index) => {
      link.reactKey = Math.random();
      link.index = index + this.props.configuration.dropdown.length;
      if (typeof link.order === "undefined" || link.order === "") {
        link.order = 100;
      }
    });

    this.initializeState();
    this.handleChange = this.handleChange.bind(this);
  }

  initializeState() {
    let urlParam = this.getUrlParameter(URL_PARAM);
    let selected;
    for (let i = 0; i < this.props.configuration.dropdown.length; i++) {
      selected = {
        valueId: "",
        nummer: "",
        id: ""
      };
      let currentConfiguration = this.props.configuration.dropdown[i];

      if (i === 0 && urlParam) {
        let firstDropdownValues = this.props.configuration.dropdown[0].values;
        for (let j = 0; j < firstDropdownValues.length; j++) {
          if (firstDropdownValues[j].id === urlParam.toUpperCase()) {
            selected = {
              valueId: firstDropdownValues[j].id,
              nummer: firstDropdownValues[j].nummer,
              id: this.props.configuration.dropdown[0].id
            };
          }
        }
      }

      this.state = {
        ...this.state,
        [i]: {
          id: "",
          label: "",
          index: currentConfiguration.index,
          default: currentConfiguration.default,
          values: "",
          show: currentConfiguration.show,
          selected
        }
      };
    }
  }

  getUrlParameter(sParam) {
    let sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  }

  handleChange(dropdownId, dropdownSelection) {
    this.resetSelectedValuesAccordingToIndex(dropdownId, dropdownSelection);
    this.changeSelectedValueOfDropdown(dropdownId, dropdownSelection);
  }

  resetSelectedValuesAccordingToIndex(dropdownId) {
    let currentIndex = this.getCurrentIndex(dropdownId);
    for (let key in this.state) {
      if (Object.prototype.hasOwnProperty.call(this.state, key)) {
        if (currentIndex < this.state[key].index) {
          this.setState({
            [key]: {
              ...this.state[key],
              selected: {
                valueId: "",
                nummer: "",
                id: this.state[dropdownId].id
              }
            }
          });
        }
      }
    }
  }

  changeSelectedValueOfDropdown(dropdownId, dropdownSelection) {
    this.setState(
      {
        [dropdownId]: {
          ...this.props.configuration.dropdown[dropdownId],
          selected: dropdownSelection
        }
      },
      this.updateAllStates
    );
  }

  getCurrentIndex(dropdownId) {
    let currentIndex;
    for (let key in this.state) {
      if (Object.prototype.hasOwnProperty.call(this.state, key)) {
        let index = this.state[key].index;
        if (index === dropdownId) {
          currentIndex = index;
        }
      }
    }
    return currentIndex;
  }

  updateStatesRecursively(counter, length, allSelectedOptions) {
    this.setState(
      prevState => ({
        [counter]: {
          ...StateValueCalculator.calculateStateValues(
            this.props.configuration.dropdown[counter],
            allSelectedOptions,
            prevState[counter].selected
          )
        }
      }),
      () => {
        allSelectedOptions[counter] = this.state[counter].selected;
        if (counter + 1 < length) {
          this.updateStatesRecursively(counter + 1, length, allSelectedOptions);
        }
      }
    );
  }

  updateAllStates() {
    let length = this.props.configuration.dropdown.length;
    this.updateStatesRecursively(0, length, this.getAllSelectedDropdowns());
  }

  getAllSelectedDropdowns() {
    let selectedDropdownOptions = [];
    for (let j = 0; j < this.props.configuration.dropdown.length; j++) {
      selectedDropdownOptions.push(this.state[j].selected);
    }
    return selectedDropdownOptions;
  }

  getPriipKey(linkConfiguration) {
    let priip = "";
    let priipKeyStructure = linkConfiguration.priipKeyStructure;
    for (let i = 0; i < priipKeyStructure.length; i++) {
      let currentKeyIndex = priipKeyStructure[i];
      if (
        Array.isArray(currentKeyIndex) &&
        this.state[currentKeyIndex[0]].selected.valueId !== undefined
      ) {
        if (this.state[currentKeyIndex[0]].selected.nummer) {
          priip += this.state[currentKeyIndex[0]].selected.nummer;
        }
      } else if (
        typeof currentKeyIndex === "string" ||
        typeof currentKeyIndex === "number"
      ) {
        priip += currentKeyIndex;
      }
      if (linkConfiguration.delimiter && i < priipKeyStructure.length - 1) {
        priip += linkConfiguration.delimiter;
      }
    }
    if (priip.charAt(priip.length - 1) === linkConfiguration.delimiter) {
      priip = priip.substring(0, priip.length - 1);
    }
    return priip;
  }

  generateDropdownComponentData() {
    let visibleDropdowns = [];
    for (let i = 0; i < this.props.configuration.dropdown.length; i++) {
      let currentValue = this.state[i];

      if (currentValue.show) {
        let configuration;
        let value = currentValue.selected.valueId;
        if (this.firstDropdownGeneration) {
          configuration = this.props.configuration.dropdown[i];
          value = configuration.default.id;
        } else {
          configuration = this.state[i];
        }
        let disabled = configuration.disabled;
        let item = {
          configuration,
          value,
          disabled
        };
        visibleDropdowns.push(item);
      }
    }
    this.firstDropdownGeneration = false;
    return visibleDropdowns;
  }

  isDropdownHidden(dropdown) {
    let conditions = dropdown.configuration.conditions;
    if (conditions && conditions.disabled) {
      return StateValueCalculator.matchConditions(
        conditions.disabled,
        this.getAllSelectedDropdowns()
      );
    }
    return false;
  }

  render() {
    let dropdownComponentData = this.generateDropdownComponentData();

    let elements = [];

    elements = elements.concat(dropdownComponentData.map(item => {
      let isHidden = this.isDropdownHidden(item);
      return {
        order: item.configuration.order,
        component: (
          <Dropdown
            key={`${item.configuration.reactKey}_${item.configuration.label}_dropdown`}
            configuration={item.configuration}
            onChildChange={this.handleChange}
            value={item.value}
            disabled={item.disabled}
            isHidden={isHidden}
          />
        )
      };
    }));

    elements = elements.concat(this.props.configuration.linkConfigurations.map(linkData => {
      let priipKey = this.getPriipKey(linkData);
      return {
        order: linkData.order,
        component: (
          <Link key={`${linkData.reactKey}_${linkData.label}_link`} priipKey={priipKey} linkData={linkData} allSelectedDropdowns={this.getAllSelectedDropdowns()} />
        )
      };
    }));

    // is order is equal (or the default order) fall back to index for sorting
    elements.sort((a, b) => {
      const orderDiff = a.order - b.order;
      if (orderDiff === 0) {
        return a.index - b.index;
      }
      return orderDiff;
    });

    return (
      <form onSubmit={this.handleSubmit}>
        {elements.map(element => element.component)}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/PriipForm.js